module.exports = __webpack_public_path__ + "media/images/banner/planning/vi-5dc25018983efe166cb8e14b281cd6d5.jpg";